import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { IdentityConstants } from '@auth';
import { SasDynamicFormService } from '../sas-dynamic-form.service';
import { FormSubmittedService } from '@services';
@Component({
    selector: 'sas-input-email-field-type',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule],
    template: `
        <div class="form-group mb-3">
            <label [for]="field.id"
                   [id]="field.id + 'Label'"
                   [title]="helpText"
                   class="form-label"
                   [textContent]="field.props.label"
                   translate="{{field.props.label}}">
            </label>
            @if (field.props.required) {
            <span> *</span>
            }
            <div [id]="field.id + 'Help'" [title]="helpText" class="sas-inline-block">
                @if (helpText.length) {
                <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
                }
            </div>
            <input type="email"
                   [name]="field.name"
                   class="form-control"
                   [ngClass]="{'is-invalid': isInvalid}"
                   [id]="field.id"
                   [attr.sas-id]="field.id"
                   [formControl]="formControl"
                   [placeholder]="!isReadonly ? (field.props.placeholder! | translate) : ''"
                   maxlength="{{field.props.maxLength}}"
                   autocomplete="email"
                   tabindex="0"
                   [required]="field.props.required ?? false"
                   [readonly]="isReadonly"
                   role="textbox"
                   [pattern]="pattern"
                   [attr.aria-invalid]="isInvalid"
                   [attr.aria-labelledby]="field.id + 'Label'"
                   [attr.aria-describedby]="field.id + 'Help'"/>
            <div [id]="field.id + 'Desc'" role="alert" aria-atomic="true" class="invalid-feedback">
                <small>{{ sasDynamicFormService.getFieldErrorMessage(field) }}</small>
            </div>
        </div>
    `,
    styleUrl: './sas-input-email-field-type.component.scss'
})
export class SasInputEmailFieldTypeComponent extends FieldType<FieldTypeConfig> {
    formSubmittedService = inject(FormSubmittedService);
    identityConstants = inject(IdentityConstants).identityConstants;
    private translate = inject(TranslateService);
    sasDynamicFormService = inject(SasDynamicFormService);

    helpText: string = '';
    pattern = this.identityConstants.regexPatternEmail;

    get isReadonly(): boolean {
        return (this.field.formControl.disabled || this.field.props.readonly) ?? false;
    }

    get isInvalid() {
        return this.field.formControl.invalid && (this.field.formControl.dirty || this.formSubmittedService.isSubmitted())
    }

    ngOnInit() {
        if (this.field.props['helptext']) {
            const helpText = this.translate.instant(this.field.props['helptext']);

            this.helpText = helpText === this.field.props['helptext'] ? '' : helpText;
        }

        this.pattern = this.field.props['validation'].pattern || this.identityConstants.regexPatternEmail;
    }
}
